(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoicePriceDialogController', InvoicePriceDialogController);

    InvoicePriceDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'ToastrService', 'LotMinDTOCustomService', 'FixationCustomService'];

    function InvoicePriceDialogController($timeout, $scope, $uibModalInstance, entity, ToastrService, LotMinDTOCustomService, FixationCustomService) {
        var vm = this;

        vm.invoicePrice = entity;
        vm.fixationsList = [];
        vm.lotsList = [];

        vm.clear = clear;
        vm.save = save;
        vm.loadFixations = loadFixations;
        vm.transformFixation = transformFixation;
        vm.loadLots = loadLots;
        vm.onFixationSelected = onFixationSelected;

        vm.init = init;

        init();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function init() {
            if (vm.invoicePrice.priceModel === 'ONCALL') {
                if (vm.invoicePrice.fixation !== null) {
                    var fixationLabel = 'Price: ' + vm.invoicePrice.fixation.pricing.price + ' with Future Price: ' + vm.invoicePrice.fixation.futurePrice
                        + '  from ' + vm.invoicePrice.fixation.pricing.month + ', ' + vm.invoicePrice.fixation.pricing.year + ' of Pricing';
                    vm.invoicePrice.fixation.label = fixationLabel;
                }
                vm.loadFixations();
            } else {
                vm.invoicePrice.price = vm.invoicePrice.fixedPrice;
                vm.invoicePrice.fixation = null;
            }
            vm.loadLots();
        }

        function loadFixations() {
            FixationCustomService.returnFixationsByShipmentId(vm.invoicePrice.shipmentId).then(function (data) {
                vm.fixationsList = data.data;
                for (var i = 0; i < vm.fixationsList.length; i++) {
                    transformFixation(vm.fixationsList[i]);
                    if (vm.invoicePrice.fixation !== undefined && vm.invoicePrice.fixation !== null) {
                        if (vm.fixationsList[i].id === vm.invoicePrice.fixation.id) {
                            vm.invoicePrice.fixation = vm.fixationsList[i];
                        }
                    }
                }
            }, function (error) {
                ToastrService.error( "Fixations not found", "Error!" );
                vm.fixationsList = [];
            });
        }

        function transformFixation(fixation) {
            var fixationLabel = 'Price: ' + fixation.pricing.price + ' with Future Price: ' + fixation.futurePrice + ', Final Price: ' + fixation.finalPriceFixationAmount
                + (fixation.pricing ? (' from ' + fixation.pricing.month + ', ' + fixation.pricing.year + ' of Pricing') : '');
            fixation.label = fixationLabel;
        }

        function loadLots() {
            LotMinDTOCustomService.getAllByShipmentId(vm.invoicePrice.shipmentId).then(function (data) {
                vm.lotsList = data.data;
                if (vm.invoicePrice.lot !== undefined && vm.invoicePrice.lot !== null) {
                    for (var i = 0; i < vm.lotsList.length; i++) {
                        if (vm.lotsList[i].id === vm.invoicePrice.lot.id) {
                            vm.invoicePrice.lot = vm.lotsList[i];
                            break;
                        }
                    }
                }
            }, function (error) {
                ToastrService.error( "Lots not found", "Error!" );
                vm.lotsList = [];
            });
        }

        function onFixationSelected() {
            vm.invoicePrice.price = vm.invoicePrice.fixation.finalPriceFixationAmount;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            $uibModalInstance.close(vm.invoicePrice);
            ToastrService.success( "Successfully saved Invoice Price", "Success!" );
        }
    }
})();
